import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "@kells/apis/analytics";
import { AppEvents } from "./shared/models/analytics";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { environment } from "../environments/environment";
@Component({
  selector: "kpr-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "member-reporting";

  constructor(
    private analyticsService: AnalyticsService,
    private router: Router
  ) {
    this.analyticsService.initialize({
      apiKey: environment.posthogApiKey,
      apiHost: environment.posthogApiHost,
    });

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        const container = document.querySelector(".app-container");
        if (container) {
          container.scrollTo({ top: 0 });
        }
      });
  }

  ngOnInit(): void {
    this.recordAppLoad();
  }

  private recordAppLoad() {
    return this.analyticsService.record(AppEvents.appLoaded({}));
  }
}
